import { Button, Dialog, Divider } from '@material-ui/core';
import { criteriaErrors } from 'Actions/projectActions';
import DialogActions from '@material-ui/core/DialogActions';
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

const ErrorsList = styled.div`
  max-height: 50vh;
  overflow-y: auto;
`;

const CriteriaErrors = ({ criteriaErr, criteriaErrors }) => {
  const handleClose = () => {
    criteriaErrors(null);
  };

  return (
    <Dialog
      classes={{
        paper: 'e-zindex--max bc-gray share-dialog',
      }}
      maxWidth="sm"
      open={criteriaErr ? true : false}
      onClose={handleClose}
    >
      <h4 className="t-primary-20 t-weight--b t-align-c u-mrg-top-30 u-mrg-bot-30 u-pad-r-25 u-pad-l-25">
        IMPORT ERRORS
      </h4>
      {typeof criteriaErr === 'object' &&
      !Array.isArray(criteriaErr) &&
      criteriaErr !== null ? (
        <ErrorsList>
          {Object.entries(criteriaErr).map(([key, value], idx) => {
            return (
              <div className="u-pad-r-25 u-pad-l-25" key={idx}>
                <div className="t-weight-b c-blue-2 t-primary-16 u-mrg-bot-10 u-mrg-top-10 u-pad-l-25">
                  {key}
                </div>
                {value.map(item => (
                  <div
                    key={item}
                    className="u-pad-l-60 t-primary-14 c-blue-2-light u-pad-r-25 u-pad-l-25 u-mrg-bot-5"
                  >
                    {item}
                  </div>
                ))}
                <Divider className="u-mrg-top-5" variant="middle" light />
              </div>
            );
          })}
        </ErrorsList>
      ) : null}
      <DialogActions>
        <Button
          classes={{
            root: 't-primary-16 c-s-blue u-mrg-top-20 u-mrg-bot-5 u-pad-r-5',
          }}
          variant="contained"
          color="primary"
          onClick={handleClose}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = store => {
  return {
    criteriaErr: store.projects.criteriaErr,
  };
};

const mapDispatchToProps = dispatch => ({
  criteriaErrors: error => {
    dispatch(criteriaErrors(error));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CriteriaErrors);
